export enum QaRegistrationFormState {
    Empty = 0,
    FullyCompleteSubQuestionsNotNeeded = 1,
    FullyCompleteSubQuestionsMissing = 2,
    FullyCompleteSubQuestionsAnswered = 3
}